import { css } from '@emotion/react'

export const item = css`
  overflow: hidden;
`

export const link = css`
  cursor: pointer;
  text-decoration: none;
`
